/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Analytics_DescInputs */

const en_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helps us understand how you use Alchema (PostHog)`)
};

const de_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilft uns zu verstehen, wie Sie Alchema nutzen (PostHog)`)
};

const fr_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous aide a comprendre comment vous utilisez Alchema (PostHog)`)
};

const es_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos ayuda a entender como usas Alchema (PostHog)`)
};

const it_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci aiuta a capire come usi Alchema (PostHog)`)
};

const nl_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpt ons te begrijpen hoe u Alchema gebruikt (PostHog)`)
};

const pl_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomaga nam zrozumiec, jak uzywasz Alchema (PostHog)`)
};

const fi_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auttaa meitä ymmärtämään, miten käytät Alchemaa (PostHog)`)
};

const da_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjaelper os med at forsta, hvordan du bruger Alchema (PostHog)`)
};

const sv_cookie_consent_analytics_desc = /** @type {(inputs: Cookie_Consent_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjalper oss forsta hur du anvander Alchema (PostHog)`)
};

/**
* | output |
* | --- |
* | "Helps us understand how you use Alchema (PostHog)" |
*
* @param {Cookie_Consent_Analytics_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_analytics_desc = /** @type {((inputs?: Cookie_Consent_Analytics_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Analytics_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_analytics_desc(inputs)
	if (locale === "fr") return fr_cookie_consent_analytics_desc(inputs)
	if (locale === "es") return es_cookie_consent_analytics_desc(inputs)
	if (locale === "it") return it_cookie_consent_analytics_desc(inputs)
	if (locale === "nl") return nl_cookie_consent_analytics_desc(inputs)
	if (locale === "pl") return pl_cookie_consent_analytics_desc(inputs)
	if (locale === "fi") return fi_cookie_consent_analytics_desc(inputs)
	if (locale === "da") return da_cookie_consent_analytics_desc(inputs)
	if (locale === "sv") return sv_cookie_consent_analytics_desc(inputs)
	return en_cookie_consent_analytics_desc(inputs)
});